import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import BackButton from "@/components/BackButton";

export default function Terms() {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-[#0A0605] text-white">
      <header className="max-w-3xl mx-auto flex items-center justify-between px-6 py-6">
        <Link to="/"><Logo size="md"/></Link>
        <BackButton fallback="/" label="Back"/>
      </header>
      <main className="max-w-3xl mx-auto px-6 pb-20 space-y-5 text-sm text-zinc-300 leading-relaxed">
        <h1 className="font-display text-3xl font-bold text-white">Terms of Service</h1>
        <p className="text-xs text-zinc-500">Effective February 2026</p>
        <Section title="Who can use NextScene">
          <p>Users of all ages are welcome. Under-13 accounts must be managed by a parent/guardian who accepts these Terms on the child's behalf. Users 13–17 need parent/guardian permission. Users 18+ accept these Terms directly.</p>
        </Section>
        <Section title="Content you upload">
          <p>You keep ownership of everything you upload. By uploading, you confirm the performance is your original work or that you have permission to share it. NextScene may remove content that violates community guidelines (spam, abuse, nudity, copyright, child safety).</p>
        </Section>
        <Section title="No guarantee">
          <p>NextScene is a discovery platform. We do not guarantee auditions, selection, employment, or any outcome from any casting call or Creator Pass subscription. Participation is at your own discretion.</p>
        </Section>
        <Section title="Payments">
          <p>Creator Pass, verification and spotlight fees are non-refundable except where required by law. Payment history is available under Settings → Payment History.</p>
        </Section>
        <Section title="Appeals & moderation">
          <p>If your account is suspended or banned you may submit an appeal from the suspension screen. Our team responds within 3 business days.</p>
        </Section>
        <p className="text-xs text-zinc-500 pt-6 border-t border-zinc-900">Continuing to use NextScene means you accept these Terms.</p>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="rounded-2xl border border-zinc-800 bg-[#180D0D] p-4">
      <h2 className="font-display text-lg font-semibold text-white mb-2">{title}</h2>
      {children}
    </div>
  );
}
